module.exports = __webpack_public_path__ + "01ea978f/img/note-list-icon.961c1485.svg";